import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Stack,
} from '@mui/material';
import {SaveTwoTone,CancelTwoTone} from '@mui/icons-material';

const Settings = (props) => {
  const [iGotIt, setGotIt] = useState(
    localStorage.iGotItOnSignUpThankYou === 'true',
  );

  const handleIGotIt = (event) => setGotIt(event.target.checked);

  const onSave = () => {
    localStorage.iGotItOnSignUpThankYou = iGotIt;
  };

  const onCancel = () => {
    props.history.goBack();
  };

  return (
    <Box component="form" sx={{ mt: 1 }}>
      <FormGroup>
        <FormControlLabel
          control={<Checkbox checked={iGotIt} onChange={handleIGotIt} />}
          label="I Got It (on Thank you message)"
        />

        <Stack spacing={2} direction="row">
          
          <Button
            startIcon={<CancelTwoTone />}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button  startIcon={<SaveTwoTone />} onClick={onSave}>
            Save
          </Button>
        </Stack>
      </FormGroup>
    </Box>
  );
};

export { Settings };
